import { Injectable } from '@angular/core';

// Interfaces
import { MyCapitalKeys } from '../../models/mycapital/mycapital-model';
import { BackendService } from '../../services/new-http/backend.service';
import { SettingsService } from '../settings/settings.service';
import { IMyCapitalAuthentication } from './interfaces/authentication.interface';
import { IMyCapital } from './interfaces/mycapital.interface';

@Injectable({
    providedIn: 'root',
  })
export class MyCapitalService {
    public id_corretora: string = "1011";
    public model = {} as IMyCapitalAuthentication;
    public mycapital = {} as IMyCapital;

    public getMD5(str: any) {
        const md5 = require("blueimp-md5");
        return md5(str);
    }

    public getRemoveChar(str: string, position: number) {
        position = position === 0 ? 24 : position;
        return str.slice(0, position-1) + str.slice(position);
    }

    public getCurrentHour() {
        let currentHour = new Date().getHours().toString();
        return currentHour.padStart(2, "0");
    }

    public getFullDate() {
        return new Date().getDate().toString().padStart(2, "0") + (new Date().getMonth()+1).toString().padStart(2, "0") + new Date().getFullYear().toString();
    }

    public getMyCapitalKeys() {
        return this.backendService.api.get('/platform/myCapital');
    }
    

    public getUrl(keys: MyCapitalKeys): string {
        this.model.chave = keys.chave;
        this.model.chave1 = keys.chave1;
        this.model.chave3 = keys.chave3;
        this.model.chave6 = keys.chave6;
        this.model.cadastro = keys.cadastro;

        const urlBase = this.settingService.getConfigurationKeyValue('myCapitalUrl');
        return `${urlBase}?chave=${this.model.chave}&chave1=${this.model.chave1}&chave3=${this.model.chave3}&chave6=${this.model.chave6}&cadastro=${this.model.cadastro}`;
    }

    constructor(
        private settingService: SettingsService,
        private backendService: BackendService,
    ) {}
}
